import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { AdvertisementTable } from '@/features/promos-offer/advertisement/table';
import { Translation } from '@/hoslog-intl';
import { GalleryIcon } from '@/icons';

import { Advertisement, STATUS } from '@/services/promos-offers/promos-offers.types';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const advertisementList: Advertisement[] = [
  {
    id: '1',
    title: 'Image Zero',
    description: 'Sed at magna dui eleifend nisl amet.',
    link: 'https://www.google.com',
    image: 'https://placehold.co/120x80/png?text=Ad+1',
    status: STATUS.ACTIVE,
    createdDate: '2024-12-12T09:15:00Z',
  },
  {
    id: '2',
    title: 'ImageOne',
    description: 'Rhoncus est vulputate elit sit tincidunt velit tristique a.',
    link: 'https://www.instagram.com',
    image: 'https://placehold.co/120x80/png?text=Ad+2',
    status: STATUS.BLOCKED,
    createdDate: '2024-12-12T09:30:00Z',
  },
  {
    id: '3',
    title: 'ImageTwo',
    description: 'Fermentum nunc pellentesque leo sagittis fringilla facilisis.',
    link: 'https://www.example.com',
    image: 'https://placehold.co/120x80/png?text=Ad+3',
    status: STATUS.BLOCKED,
    createdDate: '2024-12-12T09:45:00Z',
  },
  {
    id: '4',
    title: 'ImageThree',
    description: 'Urna arcu sed ut imperdiet maecenas at donec ac nibh.',
    link: 'https://www.twitter.com',
    image: 'https://placehold.co/120x80/png?text=Ad+4',
    status: STATUS.ACTIVE,
    createdDate: '2024-12-12T10:00:00Z',
  },
  {
    id: '5',
    title: 'ImageFour',
    description: 'Euisnacetur mollis elit nam ac scelerisque eget ullamcorper.',
    link: 'https://www.tiktok.com',
    image: 'https://placehold.co/120x80/png?text=Ad+5',
    status: STATUS.ACTIVE,
    createdDate: '2024-12-12T10:15:00Z',
  },
];

const sortItemSchema = z.object({
  id: z.enum(['title', 'description', 'link', 'status', 'createdDate']),
  desc: z.boolean(),
});

const advertisementSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  q: z.string().optional(),

  page: z.coerce.number().positive().catch(1),
});

export const Route = createFileRoute('/(app)/promos-offer/advertisement/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="adManagement.page.crumb" icon={GalleryIcon} />,
      title: <Translation id="adManagement.page.title" />,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => advertisementSchema.parse(search),
});

function RouteComponent() {
  return <AdvertisementTable data={advertisementList} />;
}
